// extracted by css-extract-rspack-plugin
export default {"paper":"paper-j1ohYt","elevation0":"elevation0-FI_nba","elevation1":"elevation1-lgghFB","elevation2":"elevation2-7y5fbv"};